(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.track = this.querySelector('[data-gallery-track]');
        this.items = [...this.querySelectorAll('[data-gallery-item]')];
        this.thumbsTrack = this.querySelector('[data-gallery-thumbs]');
        this.thumbs = [...this.querySelectorAll('[data-gallery-thumbnail]')];
        this.current = this.querySelector('[data-gallery-status]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.zoom = this.querySelector('[data-gallery-zoom-active]');
        this.dialog = this.querySelector('[data-gallery-dialog]');
        this.dialogImage = this.querySelector('[data-gallery-dialog-image]');
        this.active = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));

        this.activate(this.active, false);
        this.initialFrame = requestAnimationFrame(() => this.positionTrack(this.active, 'auto'));

        this.track?.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const index = this.activeIndex();
            if (index !== this.active) this.activate(index, true, false);
          });
        }, { passive: true, signal });

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index)), { signal });
        });

        this.previous?.addEventListener('click', () => this.goTo(this.active - 1), { signal });
        this.next?.addEventListener('click', () => this.goTo(this.active + 1), { signal });
        this.zoom?.addEventListener('click', () => this.openZoom(), { signal });
        this.querySelector('[data-gallery-close]')?.addEventListener('click', () => this.dialog?.close(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, { signal });

        this.closest('[data-product-section]')?.addEventListener('variant:change', (event) => {
          const mediaId = String(event.detail?.mediaId || '');
          const index = this.items.findIndex((item) => item.dataset.mediaId === mediaId);
          if (index >= 0) this.goTo(index);
        }, { signal });
      }

      disconnectedCallback() {
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.initialFrame);
        this.dialog?.close();
        delete this.dataset.initialized;
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.items.length - 1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.positionTrack(nextIndex, reducedMotion ? 'auto' : 'smooth');
        this.activate(nextIndex, true);
      }

      positionTrack(index, behavior) {
        const target = this.items[index];
        if (!target || !this.track) return;
        const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
        this.track.scrollTo({ left: Math.max(0, target.offsetLeft - trackInset), behavior });
      }

      activate(index, scrollThumbnail = true, announce = true) {
        this.active = Math.max(0, Math.min(index, this.items.length - 1));
        const activeItem = this.items[this.active];

        this.items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === this.active));
        this.thumbs.forEach((thumb, thumbIndex) => {
          const selected = thumbIndex === this.active;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-current', String(selected));
        });

        if (this.previous) this.previous.disabled = this.active === 0;
        if (this.next) this.next.disabled = this.active === this.items.length - 1;
        if (this.zoom) {
          const zoomable = activeItem?.dataset.mediaType === 'image';
          this.zoom.hidden = !zoomable;
          this.zoom.setAttribute('aria-label', `${this.dataset.imageLabel} ${this.active + 1}`);
        }
        if (announce && this.current) {
          this.current.textContent = `${this.dataset.imageLabel} ${this.active + 1} ${this.dataset.ofLabel} ${this.items.length}`;
        }

        if (scrollThumbnail) this.revealThumbnail(this.active);
      }

      revealThumbnail(index) {
        const thumb = this.thumbs[index];
        if (!thumb || !this.thumbsTrack) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = reducedMotion ? 'auto' : 'smooth';
        const left = thumb.offsetLeft;
        const right = left + thumb.offsetWidth;
        const visibleLeft = this.thumbsTrack.scrollLeft;
        const visibleRight = visibleLeft + this.thumbsTrack.clientWidth;
        if (left < visibleLeft) this.thumbsTrack.scrollTo({ left, behavior });
        if (right > visibleRight) this.thumbsTrack.scrollTo({ left: right - this.thumbsTrack.clientWidth, behavior });
      }

      activeIndex() {
        if (!this.track || !this.items.length) return 0;
        const trackLeft = this.track.getBoundingClientRect().left;
        return this.items.reduce((closest, item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Infinity }).index;
      }

      openZoom() {
        const activeItem = this.items[this.active];
        if (!activeItem?.dataset.zoomSrc || !this.dialog || !this.dialogImage) return;
        const preview = activeItem.querySelector('img');
        const width = preview?.naturalWidth || preview?.width || 1;
        const height = preview?.naturalHeight || preview?.height || 1;
        this.dialog.style.setProperty('--zoom-aspect', width / height);
        this.dialogImage.src = activeItem.dataset.zoomSrc;
        this.dialogImage.alt = activeItem.dataset.zoomAlt || '';
        this.dialog.showModal();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-purchase')) {
    customElements.define('product-purchase', class extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-variant-select]');
        this.price = this.querySelector('[data-product-price]');
        this.compare = this.querySelector('[data-product-compare]');
        this.buttons = [...this.querySelectorAll('[data-add-to-cart]')];
        this.buttonLabels = [...this.querySelectorAll('[data-add-label]')];
        this.buttonPrices = [...this.querySelectorAll('[data-add-price]')];
        this.buttonSeparators = [...this.querySelectorAll('[data-add-separator]')];
        this.addLabel = this.dataset.addLabel || 'Add to cart';
        this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.select?.addEventListener('change', () => this.updateVariant(), { signal });
        // Every buy CTA on the editorial page (section buttons link to #product-purchase) adds to cart,
        // which opens the cart drawer, instead of scrolling back to the buy box. Sold out keeps the scroll.
        const mainButton = this.querySelector('.pdp-form__submit');
        if (this.hasAttribute('data-editorial') && mainButton?.form) {
          document.addEventListener('click', event => {
            const link = event.target.closest('a[href="#product-purchase"]');
            if (!link || mainButton.disabled || event.defaultPrevented || event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            mainButton.form.requestSubmit(mainButton);
          }, { signal });
        }
        document.addEventListener('shopify:block:select', event => {
          if (event.target === this || this.contains(event.target)) {
            this.querySelectorAll('.pdp-purchase__details details').forEach(panel => { panel.open = true; });
          }
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (event.target === this || this.contains(event.target)) {
            this.querySelectorAll('.pdp-purchase__details details').forEach(panel => { panel.open = false; });
          }
        }, { signal });
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      updateVariant() {
        const option = this.select?.selectedOptions[0];
        if (!option) return;

        const available = option.dataset.available === 'true';
        const comparePrice = option.dataset.compare || '';
        if (this.price) this.price.textContent = option.dataset.price || '';
        if (this.compare) {
          this.compare.textContent = comparePrice;
          this.compare.classList.toggle('is-hidden', !comparePrice);
        }
        this.buttons.forEach((button) => { button.disabled = !available; });
        this.buttonLabels.forEach((label) => { label.textContent = available ? this.addLabel : this.soldOutLabel; });
        this.buttonPrices.forEach((price) => {
          price.textContent = option.dataset.price || '';
          price.hidden = !available;
        });
        this.buttonSeparators.forEach((separator) => { separator.hidden = !available; });

        this.closest('[data-product-section]')?.dispatchEvent(new CustomEvent('variant:change', {
          detail: { mediaId: option.dataset.mediaId },
          bubbles: false
        }));

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["connecting-dots"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    var MOBILE = window.matchMedia('(max-width: 899px)');
    var teardowns = new WeakMap();

    function boot(sectionEl) {
      if (teardowns.has(sectionEl)) return; /* idempotent: editor re-renders */
      var sectRoot = sectionEl.querySelector('.td-anim-sect__frame');
      var pin = sectionEl.querySelector('.td-anim-sect__pin');
      var wrap = sectionEl.querySelector('.td-wrap');
      var stage = sectionEl.querySelector('.td-stage');
      var content = sectionEl.querySelector('.td-content');
      var track = sectionEl.querySelector('.td-chart-track');
      if (!sectRoot || !pin || !wrap || !stage || !content || !track) return;

      var hA = sectionEl.querySelector('.td-hA'), hB = sectionEl.querySelector('.td-hB');
      var baseline = sectionEl.querySelector('.td-baseline'), axislabel = sectionEl.querySelector('.td-axislabel');
      var scan = sectionEl.querySelector('.td-scan'), card = sectionEl.querySelector('.td-card');
      var svg = sectionEl.querySelector('.td-threads');
      var SVGNS = 'http://www.w3.org/2000/svg';

      var DESK = { W: 1280, H: 588, X0: 140, DX: 50, BY: 338, LANES: [216, 276, 316], DAYS: 21 };
      var PORT = { W: 390, H: 560, X0: 60, DX: 100, BY: 326, LANES: [200, 234, 280], DAYS: 21 };
      var DAYSDEF = 21;
      var CFG = null, X0, DX, BY, LANES, DAYS;
      function applyCFG(c) {
        CFG = c; X0 = c.X0; DX = c.DX; BY = c.BY; LANES = c.LANES; DAYS = c.DAYS || DAYSDEF;
        stage.style.width = c.W + 'px'; stage.style.height = c.H + 'px';
        svg.setAttribute('viewBox', '0 0 ' + (c === PORT ? 2120 : c.W) + ' ' + (c === PORT ? 560 : c.H));
        wrap.classList.toggle('td-portrait', c === PORT);
        track.style.transform = '';
        track.style.width = '';
        svg.style.width = '';
        baseline.style.width = '';
      }

      var CHECKINS = [
        { day: 2, label: 'spicy takeout', kind: 'diet' },
        { day: 3, label: 'poor sleep', kind: 'life' },
        { day: 5, label: 'dairy', kind: 'diet', trigger: true },
        { day: 6, label: 'episode', kind: 'ep' },
        { day: 8, label: 'travel', kind: 'life' },
        { day: 9, label: 'salad + walk', kind: 'diet' },
        { day: 11, label: 'dairy', kind: 'diet', trigger: true },
        { day: 12, label: 'stress', kind: 'life' },
        { day: 13, label: 'episode', kind: 'ep' },
        { day: 15, label: 'dairy', kind: 'diet', trigger: true },
        { day: 16, label: 'episode', kind: 'ep' },
        { day: 18, label: 'coffee ×3', kind: 'diet' },
        { day: 19, label: 'great sleep', kind: 'life' },
        { day: 20, label: 'dairy', kind: 'diet' }
      ];
      var LINKS = [{ from: 5, to: 6, tag: '+1 day' }, { from: 11, to: 13, tag: '+2 days' }, { from: 15, to: 16, tag: '+1 day' }];

      function clamp(v) { return Math.min(1, Math.max(0, v)); }
      function seg(t, a, b) { return clamp((t - a) / (b - a)); }
      function eoC(p) { return 1 - Math.pow(1 - p, 3); }
      function eiC(p) { return p * p * (3 - 2 * p); }
      function eoBack(p) { var c = 1.70158; return 1 + (c + 1) * Math.pow(p - 1, 3) + c * Math.pow(p - 1, 2); }

      stage.style.transformOrigin = '0 0';
      function fit() {
        var r = wrap.getBoundingClientRect();
        if (CFG === PORT) {
          CFG.W = Math.min(r.width, 540);
          stage.style.width = CFG.W + 'px';
          var nextDX = Math.min(100, (CFG.W - 120) / 2);
          var geometryChanged = nextDX !== DX;
          CFG.DX = DX = nextDX;
          var trackWidth = X0 * 2 + DX * (DAYS - 1);
          track.style.width = trackWidth + 'px';
          svg.style.width = trackWidth + 'px';
          svg.setAttribute('viewBox', '0 0 ' + trackWidth + ' 560');
          baseline.style.width = (DX * (DAYS - 1)) + 'px';
          CFG.H = 360 + card.offsetHeight + 24;
          stage.style.height = CFG.H + 'px';
          wrap.style.setProperty('--td-height', CFG.H + 'px');
          r = wrap.getBoundingClientRect();
          if (geometryChanged && built) rebuildAll();
        }
        sectRoot.style.setProperty('--td-stage-height', r.height + 'px');
        var s = Math.min(r.width / CFG.W, r.height / CFG.H);
        stage.style.transform = 'translate(' + ((r.width - CFG.W * s) / 2) + 'px,' + ((r.height - CFG.H * s) / 2) + 'px) scale(' + s + ')';
      }
      var curMode = null;
      function fitMode() {
        var m = MOBILE.matches ? 'P' : 'D';
        if (m !== curMode) { curMode = m; applyCFG(m === 'P' ? PORT : DESK); }
        fit();
      }

      var dots = [], pulses = [], pills = [], conns = [], threads = [], enddots = [];
      function dayX(d) { return X0 + (d - 1) * DX; }
      function build() {
        var i, c, d, x;
        for (d = 1; d <= DAYS; d++) {
          x = dayX(d);
          var isEp = CHECKINS.some(function (cc) { return cc.day === d && cc.kind === 'ep'; });
          var el = document.createElement('div');
          el.className = 'dot' + (isEp ? ' ep' : '');
          el.style.left = x + 'px'; el.style.top = BY + 'px';
          track.appendChild(el);
          dots.push({ el: el, s: 1.1 + (d - 1) * (CFG === PORT ? 0.22 : 0.14) });
          if (isEp) {
            for (i = 0; i < 2; i++) {
              var p = document.createElement('div');
              p.className = 'pulse'; p.style.left = x + 'px'; p.style.top = BY + 'px';
              track.appendChild(p);
              pulses.push({ el: p, s: 1.1 + (d - 1) * 0.14 + 0.55, off: i * 1.2 });
            }
          }
        }
        CHECKINS.filter(function (c) { return c.day <= DAYS; }).forEach(function (c, idx) {
          x = dayX(c.day);
          var insideLink = LINKS.some(function (link) { return c.day > link.from && c.day < link.to; });
          var laneY = CFG === PORT
            ? LANES[c.kind === 'ep' ? 1 : (c.kind === 'diet' ? 0 : 2)]
            : LANES[c.trigger ? 0 : (c.kind === 'ep' ? 1 : (insideLink ? 2 : c.day % 2))];
          var conn = document.createElement('div');
          conn.className = 'conn';
          var top = laneY + 15, h = BY - 6 - top;
          conn.style.left = x + 'px'; conn.style.top = top + 'px'; conn.style.height = h + 'px';
          track.appendChild(conn);
          var el = document.createElement('div');
          el.className = 'pill ' + c.kind;
          el.textContent = c.label;
          el.style.left = x + 'px'; el.style.top = laneY + 'px';
          track.appendChild(el);
          var rec = { el: el, conn: conn, day: c.day, kind: c.kind, focus: (c.kind === 'ep' || !!c.trigger),
            s: 1.1 + (c.day - 1) * (CFG === PORT ? 0.22 : 0.14) + 0.5, seed: idx * 1.73, x: x, laneY: laneY };
          pills.push(rec); conns.push(rec);
        });
      }
      function buildThreads() {
        pills.forEach(function (p) { p.h = p.el.offsetHeight || 27; p.w = p.el.offsetWidth; });
        LINKS.forEach(function (L, k) {
          var a = null, b = null;
          pills.forEach(function (p) { if (p.day === L.from) a = p; if (p.day === L.to) b = p; });
          if (!a || !b) return;
          var x1 = a.x, y1 = a.laneY - a.h / 2 - 2, x2 = b.x, y2 = b.laneY - b.h / 2 - 2;
          var span = Math.abs(b.day - a.day);
          var apex = Math.min(y1, y2) - (CFG === PORT ? 86 : 72 + 24 * (span - 1));
          var cx = (x1 + x2) / 2;
          var path = document.createElementNS(SVGNS, 'path');
          path.setAttribute('d', 'M ' + x1 + ' ' + y1 + ' Q ' + cx + ' ' + apex + ' ' + x2 + ' ' + y2);
          svg.appendChild(path);
          var len = path.getTotalLength();
          path.style.strokeDasharray = len;
          path.style.strokeDashoffset = len;
          var g1 = document.createElementNS(SVGNS, 'circle');
          g1.setAttribute('cx', x1); g1.setAttribute('cy', y1); g1.setAttribute('r', 2.6);
          var g2 = document.createElementNS(SVGNS, 'circle');
          g2.setAttribute('cx', x2); g2.setAttribute('cy', y2); g2.setAttribute('r', 2.6);
          [g1, g2].forEach(function (g) {
            g.style.transformOrigin = g.getAttribute('cx') + 'px ' + g.getAttribute('cy') + 'px';
            g.style.transform = 'scale(0)'; svg.appendChild(g);
          });
          var mx = 0.25 * x1 + 0.5 * cx + 0.25 * x2, my = 0.25 * y1 + 0.5 * apex + 0.25 * y2;
          var tag = document.createElement('div');
          tag.className = 'tag'; tag.textContent = L.tag;
          tag.style.left = mx + 'px'; tag.style.top = (my - 10) + 'px';
          track.appendChild(tag);
          threads.push({ path: path, len: len, g1: g1, g2: g2, tag: tag, s: CFG === PORT ? 9.2 + k * 2.65 : 10.6 + k * 1.05, d: 1.25 });
        });
      }
      function render(t) {
        renderedT = t;
        var i;
        if (CFG === PORT) {
          var maxPan = X0 * 2 + DX * (DAYS - 1) - CFG.W;
          var focus = function (link) { return Math.max(0, Math.min(maxPan, (dayX(link.from) + dayX(link.to)) / 2 - CFG.W / 2)); };
          var pan = Math.max(0, Math.min(maxPan, dayX(1 + 20 * seg(t, 1.6, 6.0)) - CFG.W * 0.65));
          if (t >= 6.4) pan += (focus(LINKS[0]) - pan) * eiC(seg(t, 6.4, 8.6));
          if (t >= 10.6) pan = focus(LINKS[0]) + (focus(LINKS[1]) - focus(LINKS[0])) * eiC(seg(t, 10.6, 11.65));
          if (t >= 13.25) pan = focus(LINKS[1]) + (focus(LINKS[2]) - focus(LINKS[1])) * eiC(seg(t, 13.25, 14.3));
          track.style.transform = 'translateX(' + (-pan) + 'px)';
        }
        content.style.opacity = String(1 - seg(t, 20.9, 21.8));
        var ain = eoC(seg(t, 0.3, 1.2)), aout = seg(t, 6.6, 7.4);
        hA.style.opacity = String(ain * (1 - aout));
        hA.style.transform = 'translateY(' + ((1 - ain) * 12 - aout * 8) + 'px)';
        var bin = eoC(seg(t, 7.6, 8.6)), bout = seg(t, 19.4, 20.3);
        hB.style.opacity = String(bin * (1 - bout));
        hB.style.transform = 'translateY(' + ((1 - bin) * 12 - bout * 8) + 'px)';
        baseline.style.transform = 'scaleX(' + eoC(seg(t, 0.5, 1.5)) + ')';
        axislabel.style.opacity = String(seg(t, 1.3, 2.1) * (1 - seg(t, 20.9, 21.6)));
        for (i = 0; i < dots.length; i++) {
          var dd = dots[i], p = seg(t, dd.s, dd.s + 0.55);
          dd.el.style.transform = 'translate(-50%,-50%) scale(' + eoBack(p) + ')';
          dd.el.style.opacity = String(seg(t, dd.s, dd.s + 0.3));
        }
        for (i = 0; i < pulses.length; i++) {
          var pu = pulses[i];
          if (t < pu.s) { pu.el.style.opacity = '0'; continue; }
          var pr = ((t - pu.s + pu.off) % 2.4) / 2.4;
          pu.el.style.transform = 'translate(-50%,-50%) scale(' + (1 + pr * 2.6) + ')';
          pu.el.style.opacity = String((1 - pr) * 0.45);
        }
        var dim = seg(t, 10.0, 11.0);
        for (i = 0; i < pills.length; i++) {
          var pl = pills[i], q = eoC(seg(t, pl.s, pl.s + 0.7));
          var fl = CFG === PORT || pl.focus ? 0 : Math.sin(t * 0.85 + pl.seed) * 2.4 * q;
          var rise = (1 - q) * 12;
          var d = pl.focus || CFG === PORT ? 1 : (1 - 0.62 * dim);
          if (CFG === PORT) {
            var half = pl.w / 2, edge = Math.min(pl.x - pan - half, CFG.W - (pl.x - pan) - half);
            d *= clamp(edge / 16);
          }
          pl.el.style.opacity = String(seg(t, pl.s, pl.s + 0.4) * d);
          pl.el.style.transform = 'translate(-50%,-50%) translateY(' + (rise + fl) + 'px)';
          pl.conn.style.transform = 'scaleY(' + q + ')';
          pl.conn.style.opacity = String(0.9 * d);
        }
        var sx = -180 + (CFG.W + 360) * eiC(seg(t, 7.6, 9.8));
        scan.style.transform = 'translateX(' + sx + 'px)';
        scan.style.opacity = String(seg(t, 7.6, 8.0) * (1 - seg(t, 9.4, 9.8)));
        for (i = 0; i < threads.length; i++) {
          var th = threads[i], tp = eiC(seg(t, th.s, th.s + th.d));
          th.path.style.strokeDashoffset = String(th.len * (1 - tp));
          var gs = eoBack(seg(t, th.s + th.d * 0.7, th.s + th.d * 0.7 + 0.4));
          th.g1.style.transform = 'scale(' + gs + ')';
          th.g2.style.transform = 'scale(' + gs + ')';
          th.tag.style.opacity = String(seg(t, th.s + th.d * 0.9, th.s + th.d * 0.9 + 0.5));
        }
        var cp = eoC(seg(t, CFG === PORT ? 16.4 : 15.9, CFG === PORT ? 17.5 : 17.0)), co = seg(t, 19.9, 20.6);
        card.style.opacity = String(cp * (1 - co));
        card.style.transform = 'translateX(-50%) translateY(' + ((1 - cp) * 18 - co * 6) + 'px)';
      }

      var built = false, disposed = false, renderedT = 17.5;
      function rebuildAll() {
        dots.forEach(function (r) { r.el.remove(); });
        pulses.forEach(function (r) { r.el.remove(); });
        pills.forEach(function (r) { r.el.remove(); if (r.conn) r.conn.remove(); });
        threads.forEach(function (r) { if (r.tag) r.tag.remove(); });
        svg.innerHTML = '';
        dots = []; pulses = []; pills = []; conns = []; threads = []; enddots = [];
        build(); buildThreads();
      }

      var onModeResize = function () {
        var m = MOBILE.matches ? 'P' : 'D';
        if (m !== curMode && built) { fitMode(); rebuildAll(); render(renderedT); } else { fit(); if (built) render(renderedT); }
      };

      var scrubs = null; /* set once scrub() is armed */

      function scrub() {
        var START = 1.2, END = 19.2, target = START, cur = -1, raf = null;
        function measure() {
          var rr = sectRoot.getBoundingClientRect();
          var pinTop = parseFloat(window.getComputedStyle(pin).top) || 0;
          var distance = Math.max(1, rr.height - pin.offsetHeight);
          target = START + clamp((pinTop - rr.top) / distance) * (END - START);
        }
        function frame() {
          raf = null;
          var d = target - cur;
          if (Math.abs(d) > 0.004) {
            cur += d * 0.18;
            if (Math.abs(target - cur) <= 0.006) cur = target;
            render(cur);
            raf = requestAnimationFrame(frame);
          }
        }
        function kick() { measure(); if (raf === null) raf = requestAnimationFrame(frame); }
        window.addEventListener('scroll', kick, { passive: true });
        window.addEventListener('resize', kick);
        measure(); cur = target; render(cur);
        return function () {
          window.removeEventListener('scroll', kick);
          window.removeEventListener('resize', kick);
          if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
        };
      }

      window.addEventListener('resize', onModeResize);

      fitMode();
      build();
      var finish = function () {
        if (disposed || !sectionEl.classList.contains('is-ready')) return;
        if (scrubs) { scrubs(); scrubs = null; }
        var still = REDUCED.matches || !!(window.Shopify && window.Shopify.designMode);
        sectionEl.classList.toggle('is-animated', !still);
        fit();
        if (still) { render(17.5); } else { scrubs = scrub(); }
      };
      var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      ready.then(function () {
        if (disposed) return;
        sectionEl.classList.add('is-ready');
        fit();
        buildThreads();
        finish();
        built = true;
      });

      REDUCED.addEventListener('change', finish);
      MOBILE.addEventListener('change', finish);
      teardowns.set(sectionEl, function () {
        disposed = true;
        REDUCED.removeEventListener('change', finish);
        MOBILE.removeEventListener('change', finish);
        window.removeEventListener('resize', onModeResize);
        if (scrubs) { scrubs(); scrubs = null; }
      });
    }

    function bootAll(root) {
      (root || document).querySelectorAll('.connecting-dots').forEach(function (el) {
        boot(el);
      });
    }

    bootAll(document);

    /* Theme editor lifecycle: re-rendered sections boot fresh, removed ones clean up. */
    document.addEventListener('shopify:section:load', function (event) {
      bootAll(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.connecting-dots').forEach(function (el) {
        var teardown = teardowns.get(el);
        if (teardown) { teardown(); teardowns.delete(el); }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
